/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { memo, Fragment } from 'react';
import { FormPageAuthProperty, Design } from 'shared';
import { FormField } from './FormField';

type PropertiesProps = {
  properties: FormPageAuthProperty[];
  disabled: boolean;
  design: Design;
};

export const Properties: React.FC<PropertiesProps> = memo(
  ({ properties, disabled, design }) => {
    return (
      <Fragment>
        {properties.map((property) => {
          const { propertyId } = property;
          return (
            <FormField
              css={css`
                &:not(:last-child) {
                  margin-bottom: 24px;
                }
              `}
              key={propertyId}
              property={property}
              disabled={disabled}
              design={design}
            />
          );
        })}
      </Fragment>
    );
  },
);
